import LightCard from "../../../../../../../../components/card/LightCard";
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";
import { useTranslation } from "react-i18next"
import React, {Fragment, useEffect, useState} from "react";
import AdditionalMusicianItem from "./AdditionalMusicianItem";
import PopupWithContext from "../../../../../../../../components/ui/Popup/PopupWithContext";
import AdditionalCostPopupForm from "./popupForm/AdditionalCostPopupForm";
import OkBtnPopupContext from "../../../../../../../../components/ui/Popup/OkBtnPopupContext";
import AddMusCostsMainTitles from "./AddMusCostsMainTitles";
import AddTotalCostsFooter from "./AddTotalCostsFooter";


const popupInit = {show: false, title: '', variant: 'error', message: ''}


export const AdditionalProjectCosts = ({additional_musicians}) => {
    const { t } = useTranslation()
    const [popup, setPopup] = useState(popupInit)
    const [peoples, setPeoples] = useState([])
    const [categorise_sum, setCategorise_sum] = useState({})


    useEffect(() => {
        const additional_musicians_copy = structuredClone(additional_musicians);
        setPeoples([...additional_musicians_copy]);
    }, [])

    const handlePopup = (type, musician, newValue) => {
        if (type === 'cancel') {
            setPopup(popupInit)
        }
        if (type === 'additionalForm') {
            setPopup({
                show: true,
                title: t("popups.formular_data.title"),
                variant: 'editF',
                message: t("popups.formular_data.description"),
                leftBtn: t("common.button.save"),
                rightBtn: t("common.button.cancel"),
                handlerPopup: "handleOkClick",
                formName: "additionalForm",
                formData: musician,
            })
        }

        if (type === 'save') {
            const peoples_copy = structuredClone(peoples)
            const categorie_music = peoples_copy.find(el => el.musician_id === musician.musician_id)
            if (categorie_music) {
                categorie_music.categories.push(newValue)
                setPeoples(peoples_copy)
            }
            setPopup(popupInit)
        }
    }

    const popupForm = {
        additionalForm: <AdditionalCostPopupForm
            handlePopup={handlePopup}
            formData={popup.formData}
            saveBtn={t(popup.leftBtn)}
            cancelBtn={t(popup.rightBtn)}
        />,
        // globalSave: <SavingPopupContext
        //     handlePopup={handlePopup}
        //     saveBtn={t(state.popup.leftBtn)}
        //     cancelBtn={t(state.popup.rightBtn)}
        // />,
        OkBtn: <OkBtnPopupContext okBtn={t(popup.okBtn)} handlePopup={handlePopup} />,
    }

    const changeHandler = (fieldName, val, musician_id, categ_entry_id) => {
        const musicianCopy = structuredClone(peoples);
        const musicianItem = musicianCopy.find(item => item.musician_id === musician_id)
        if (musicianItem.categories && musicianItem.categories.length > 0) {
            const musicianCategItem = musicianItem.categories.find(item => item.id === categ_entry_id)
            musicianCategItem[fieldName] = val
            setPeoples(musicianCopy)
            setCategorise_sum({
                ...categorise_sum,
                [musicianCategItem.id]: {
                    client_cost: Number(musicianCategItem.client_cost),
                    estro_cost: Number(musicianCategItem.estro_cost)
                }
            })
        }
    }

    const saveHandler = () => {
        console.log("SAVE", peoples)
    }

    const summary_costs = () => {
        const summ_costs = Object.values(categorise_sum).reduce((acc, elem) => {
            acc.client_cost = acc.client_cost + Number(elem.client_cost)
            acc.estro_cost = acc.estro_cost + Number(elem.estro_cost)
            return acc
        }, {client_cost: 0.00, estro_cost: 0.00})
        return summ_costs
    }

    console.log(peoples)

    return (<>
        {popup.show
            ?  <PopupWithContext
                    variant={popup.variant}
                    title={t(popup.title)}
                    message={t(popup.message)}
                >
                    {popupForm[popup.formName]}
                </PopupWithContext>
            : (<>
                <LightCard>
                    <RedHeader title={t('events.summary.addi_mus_costs_title')} />
                    <AddMusCostsMainTitles />
                    {
                        peoples.map((musician, index) => (<Fragment key={index}>
                                <AdditionalMusicianItem
                                    musician={musician}
                                    index={index+1}
                                    handlePopup={handlePopup}
                                    changeHandler={changeHandler}
                                />
                            </Fragment>)
                        )
                    }
                    <AddTotalCostsFooter data={summary_costs()} saveHandler={saveHandler}  />
                </LightCard>
              </>)
        }
    </>);
}